import getters from "./ProfilsDesInvestisseursGetters";
import actions from "./ProfilsDesInvestisseursActions";
import mutations from "./ProfilsDesInvestisseursMutations";

const state = {
    investors: []
};

export default {
    state,
    getters,
    actions,
    mutations
};
